<template>
  <div>
    <div class="row">
      <div class="col-xs-4">
        <ul class="pagination pagination-sm no-margin">
          <li class="paginate_button previous">
            <b-btn class="paginate_button previous" :disabled="index === sorted.length -1" @click="moveMonth('prev')"><< prev</b-btn>
          </li>
          <li class="paginate_button active" v-if="sorted && sorted[index]">
            <b-btn class="btn btn-info">{{sorted[index].split('-')[1] | translate}} {{sorted[index].split('-')[0]}}</b-btn>
          </li>
          <li class="paginate_button next">
            <b-btn @click="moveMonth('next')" class="btn btn-info" :disabled="index === 0">next >></b-btn>
          </li>
        </ul>
      </div>
    </div>
    <hr>
    <div class="row">
      <div  class="col-md-3">
        <div class="small-box">
          <div class="box-header no-border">
            <h3 class="box-title">Amazon</h3>
          </div>
          <div class="info-box no-margin">
            <span class="info-box-icon"><i class="fa fa-ban"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">
                {{amazon }}
                {{ 'cancellations'| translate}}
              </span>
              <span class="info-box-number">
                <template v-if="total > 0">
                    {{amazon * 100 / total| currency('%')}}
                  </template>
                  <template v-else>
                    {{0 | currency('%')}}
                  </template>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-md-3">
        <div class="small-box">
          <div class="box-header no-border">
            <h3 class="box-title">Zalando</h3>
          </div>
          <div class="info-box no-margin">
            <span class="info-box-icon"><i class="fa fa-ban"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">
                {{zalando }}
                {{ 'cancellations'| translate}}
              </span>
              <span class="info-box-number">
                  <template v-if="total > 0">
                    {{zalando * 100 / total| currency('%')}}
                  </template>
                  <template v-else>
                    {{0 | currency('%')}}
                  </template>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-md-3">
        <div class="small-box ">
          <div class="box-header no-border">
            <h3 class="box-title">eBay</h3>
          </div>
          <div class="info-box no-margin">
            <span class="info-box-icon"><i class="fa fa-ban"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">
                {{ebay}} {{ 'cancellations'| translate}}
              </span>
              <span class="info-box-number">
                <template v-if="total > 0">
                    {{ebay * 100 / total| currency('%')}}
                  </template>
                  <template v-else>
                    {{0 | currency('%')}}
                  </template>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-md-3">
        <div class="small-box">
          <div class="box-header no-border">
            <h3 class="box-title">schuhe.de</h3>
          </div>
          <div class="info-box no-margin">
            <span class="info-box-icon"><i class="fa fa-ban"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">
                {{schuhe }}
                {{ 'cancellations'| translate}}
              </span>
              <span class="info-box-number">
                  <template v-if="total > 0">
                    {{schuhe * 100 / total| currency('%')}}
                  </template>
                  <template v-else>
                    {{0 | currency('%')}}
                  </template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
		data () {
			return {
				sorted: [],
        items: [],
        index: 0,
				amazon: 0,
				total: 0,
				ebay: 0,
				schuhe: 0,
				zalando: 0,
				marketplace: 1,
				marketplaces: [
					{label: 'Amazon', id: 1},
					{label: 'Zalando', id: 2},
					{label: 'eBay', id: 3},
					{label: 'Schuhe.de', id: 4}
				],
				pagination: {
					total: 0,
					per_page: 25,
					current_page: 1,
					total_pages: 0
				}
			}
		},
		methods: {
			processResponse (data) {
				this.items = data
				let keys = Object.keys(data)
				this.sorted = keys.sort().reverse()
				this.amazon = data[this.sorted[0]].channels.amazon.total
				this.ebay = data[this.sorted[0]].channels.ebay.total
				this.schuhe = data[this.sorted[0]].channels.schuhede.total
				this.zalando = data[this.sorted[0]].channels.zalando.total
				this.total = data[this.sorted[0]].total
			},
      moveMonth (key) {
				this.index = key === 'prev' ? this.index + 1 : this.index - 1
	      this.amazon = this.items[this.sorted[this.index]].channels.amazon.total
	      this.ebay = this.items[this.sorted[this.index]].channels.ebay.total
	      this.schuhe = this.items[this.sorted[this.index]].channels.schuhede.total
	      this.zalando = this.items[this.sorted[this.index]].channels.zalando.total
	      this.total = this.items[this.sorted[this.index]].total
      }
		},
		mounted () {
			API.get('/statistics/stats/companies/1')
				.then(res => {
					this.processResponse(res.data.monthly_cancellations)
				})
				.catch(error => {
				})
		},
		watch: {

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/tools/MarketplaceStats.vue